import axios from 'axios';

export default axios.create({
  baseURL: 'https://fitness-buddy-backend.onrender.com/api',
});
